export default __webpack_public_path__ + "static/media/pin.e8ed9c24.svg";